
import React, { Component } from 'react';
import { CSVLink, CSVDownload } from 'react-csv';
import { Modal } from 'react-bootstrap';

export default class MessageBox extends Component {
    constructor(props) {
        super(props)
        this.state = {
            lstMsg: props.lstMsg || [],
            isShowMessageBox: false,
        }
    }

    render() {
        return (
            <Modal bsSize='large' show={this.props.isShowMessageBox} onHide={this.props.onCloseMessageBox}>
                <Modal.Header closeButton>
                    <Modal.Title>{`Error`}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/* table: this.fileName, row: rowNumber, column: error.field, value: error.value, reason: error.reason */}
                    <div style={{ position: 'relative', 'maxHeight': '500px', overflowY: 'scroll', marginBottom: '30px' }}>
                        <div className="content table-responsive table-full-width">
                            <table className="table table-hover table-striped">
                                <thead>
                                    <tr>
                                        <th>No.</th>
                                        <th>Table</th>
                                        <th>Row</th>
                                        <th>Column</th>
                                        <th>Value</th>
                                        <th>Description</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.lstMsg.map((item, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{item.table}</td>
                                                <td>{item.row}</td>
                                                <td>{item.column}</td>
                                                <td>{item.value}</td>
                                                <td>{item.reason}</td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div style={{ float: 'right' }}>
                        <CSVLink
                            data={this.state.lstMsg}
                            filename={"Errors.csv"}
                            className="btn btn-primary"
                            target="_blank"
                            style={{
                                backgroundColor: '#FFE600',
                                borderColor: '#7F7E82',
                                borderRadius: '5px',
                                fontWeight: 600
                            }}
                        >
                            DOWNLOAD
                        </CSVLink>
                    </div>
                </Modal.Footer>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// src/components/MessageBox.js